import React, { Component }  from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';

import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import IconButton from '@material-ui/core/IconButton';
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore';
import Typography from '@material-ui/core/Typography';
import {Auth} from 'aws-amplify';

import Switch from '@material-ui/core/Switch';
import ReactGA from 'react-ga';


const styles = theme => ({
  button: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    alignItems: 'right',
  },
  leftIcon: {
    marginRight: theme.spacing.unit,
  },
  rightIcon: {
    marginLeft: theme.spacing.unit,
  },
  iconSmall: {
    fontSize: 20,
  },
  detailHeader: {
    backgroundColor: theme.palette.primary.main,
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    //paddingLeft: '5px',
    //paddingTop: '5px',
  },
  contrastText: {
    color: theme.palette.primary.contrastText,
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: '100%',
  },
  listText: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: '100%',
  },
  buttonList: {
    textAlign: 'right',
  }
});

class Settings extends Component {
  constructor(props) {
    super(props);

    this.updateSettings = this.updateSettings.bind(this);
    this.validateEmail = this.validateEmail.bind(this);
    this.state = {
      cognitoUser: '',
      given_name: '',
      family_name: '',
      email: '',
      phone_number: '',
      subFavoriteEmail: false,
      contactPhoneText: false,
      isDirty: false,
      emailNotValidMessage: '',
      emailValidationFailed: false,
    };
  }

  componentWillMount() {
    this.getCognitoUserSession();

    ReactGA.initialize('UA-107081605-2');
    ReactGA.pageview(window.location.pathname + window.location.search);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {

  }

  validateEmail = (email) => {
    var re = /[^\s@]+@[^\s@]+\.[^\s@]+/;
    return re.test(String(email).toLowerCase());
  }

  //get the logged-in user session
  getCognitoUserSession = async () => {
    //console.log('now in getCognitoUserSession()');
    try {
      Auth.currentAuthenticatedUser()
        .then(data => {
          //console.log(data);
          this.setState({
              cognitoUser: data,
              given_name: data.attributes.given_name,
              family_name: data.attributes.family_name,
              email: data.attributes.email,
              phone_number: data.attributes.phone_number,
              subFavoriteEmail: data.attributes['custom:subFavoriteEmail'] || false,
              contactPhoneText: data.attributes['custom:contactPhoneText'] || false,
          });
        })
    } catch (err) {
      console.log('error fetching user info: ', err);
    }
  }

  updateSettings() {
    if (this.state.emailValidationFailed) {
      this.setState({ emailNotValidMessage: 'Please check the email address and try again.'});
    } else {
      try {
        Auth.updateUserAttributes(this.state.cognitoUser, {
          "given_name": this.state.given_name,
          "family_name": this.state.family_name,
          "email": this.state.email,
          "phone_number": this.state.phone_number,
          "custom:subFavoriteEmail": this.state.subFavoriteEmail.toString(),
          "custom:contactPhoneText": this.state.contactPhoneText.toString(),
        });
        this.setState({ isDirty: false });
      } catch (err) {
        console.log('error updating user settings: ', err);
      }
    }
  }

  handleBackClick = () => {
    //console.log('back clicked');
    this.props.history.goBack()
  }

  handleSwitchChange = name => event => {
    this.setState({ [name]: event.target.checked, isDirty: true });
  };

  handleTextFieldChange = name => event => {
    this.setState({ [name]: event.target.value, isDirty: true });
    if (name === 'email') {
      if (this.validateEmail(this.state.email)) {
        this.setState({ emailNotValidMessage: '', emailValidationFailed: false });
      } else {
        this.setState({ emailNotValidMessage: 'This email address is not valid.', emailValidationFailed: true });
      }
    }
  }

  render() {
    const { classes } = this.props;
    const { given_name, family_name, phone_number, email } = this.state;
    const { subFavoriteEmail, contactPhoneText, isDirty, emailNotValidMessage, emailValidationFailed } = this.state;

    return (
      <div>
            <Paper className={classes.detailHeader}>
              <IconButton className={classes.contrastText} aria-label="Menu" onClick={this.handleBackClick}>
                <NavigateBeforeIcon />
              </IconButton>

              <Typography className={classes.contrastText}  variant="subheading" color="inherit">
                SETTINGS
              </Typography>
            </Paper>
            <Paper>
              <Grid container alignItems="stretch" justify="center" spacing={8}>
                <Grid item xs={6} sm={6}>
                  <ListItem>
                    <TextField
                      id="email"
                      label="First Name"
                      className={classes.textField}
                      value={given_name}
                      onChange={this.handleTextFieldChange('given_name')}
                      margin="normal"
                    />
                  </ListItem>
                </Grid>
                <Grid item xs={6} sm={6}>
                  <ListItem>
                    <TextField
                      id="email"
                      label="Last Name"
                      className={classes.textField}
                      value={family_name}
                      onChange={this.handleTextFieldChange('family_name')}
                      margin="normal"
                    />
                  </ListItem>
                </Grid>
              </Grid>

              <ListItem>
                <TextField
                  id="email"
                  label="Email"
                  className={classes.textField}
                  value={email}
                  onChange={this.handleTextFieldChange('email')}
                  margin="normal"
                  helperText={emailNotValidMessage}
                  error={emailValidationFailed}
                />
              </ListItem>
              <ListItem>
                <TextField
                  id="email"
                  label="Phone"
                  className={classes.textField}
                  value={phone_number}
                  onChange={this.handleTextFieldChange('phone_number')}
                  margin="normal"
                />
              </ListItem>

              <ListItem>
                <ListItemText className={classes.listText} primary="Get email notifications related to favorited and/or top lease offers" />
                <Switch
                  checked={subFavoriteEmail}
                  onChange={this.handleSwitchChange('subFavoriteEmail')}
                  value="subFavoriteEmail"
                  color="primary"
                />
              </ListItem>



              <ListItem>
                <ListItemText className={classes.listText} primary="Can we call or text you about a certain lease offer?" />
                <Switch
                  checked={contactPhoneText}
                  onChange={this.handleSwitchChange('contactPhoneText')}
                  value="contactPhoneText"
                  color="primary"
                />
              </ListItem>



              <ListItem className={classes.buttonList}>
                <ListItemText className={classes.listText} primary="" />
                <Button className={classes.button} color="primary" variant="raised" onClick={this.handleBackClick}>Cancel</Button>
                <Button className={classes.button} disabled={!isDirty} color="primary" variant="raised" onClick={this.updateSettings}>Save</Button>
              </ListItem>


            </Paper>
      </div>
    );
  }

}

Settings.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Settings);



// WEBPACK FOOTER //
// ./src/components/Settings.jsx